import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Travel } from 'src/app/models/travel';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { TravelService } from '../../services/travel/travel.service';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';

@Component({
  selector: 'app-travel-authorization-cancel',
  templateUrl: './travel-authorization-cancel.component.html',
  styleUrls: ['./travel-authorization-cancel.component.scss']
})
export class TravelAuthorizationCancelComponent implements OnInit {

  _travel: Travel;
  formGroup: FormGroup;
  loading:boolean;
  error_handler_reason ='';

  constructor(
    public dialogRef: MatDialogRef<TravelAuthorizationCancelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public travelService: TravelService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this._travel = new Travel('');
    this.formGroup = this.formBuilder.group({
      status: ['',null],
      status_id: ['',null],
      reason:['',null],
    });
    this._travel.formGroup = this.formGroup;
  }

  
  closeOnClick() {
    this.dialogRef.close('');
  }

  save(){
    this.loading = true;
    if (this.data.status == undefined) {
      this.formGroup.controls['status'].setValue("Cancelled");
      this.travelService.updateStatus(this.data.id,this.formGroup.value).subscribe(res=>{
        this.loading = false;
        this.formGroup.controls['status_id'].setValue(res['data'].data[0].status_id);
        this.dialog.open(NotifyboxComponent, {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            isclose:true,
            message: res['message']
          }
        }).afterClosed().subscribe(result => {
          if (result) {
            this.dialogRef.close(this.formGroup.value);
          }
        });
      }, (err => {
        this.loading = false;
        // this.dialog.open(NotifyboxComponent, {
        //   disableClose:true,
        //   data: {
        //     reload:false,
        //     label:'Ok',
        //     isclose:true,
        //     message: err.error.errors.reason ? err.error.errors.reason[0] : err.error.errors.push_back[0]
        //   }
        // }).afterClosed().subscribe(result => {
        //   if (result) {
        //     // this.dialogRef.close(this.formGroup.value);
        //   }
        // });
        this._travel.setErrors(err.error.errors);
        this._travel.triggerErrors(err.error.errors);
        
    }));
    } else {
      let status = "";
      if (this.data.status == 3) {
        status = "Approved";
      } else if (this.data.status == 4) {
        status = "Rejected";
      } else if (this.data.status == 5) {
        status = "Cancelled";
      } else if (this.data.status == 6) {
        status = "Push Back";
      } else if (this.data.status == 101) {
        status = "Approved";
      } else if (this.data.status == 104) {
        status = "Close TR";
      }
      this.formGroup.controls['status'].setValue(status);
      this.travelService.approverUpdateStatus(this.data.id,this.formGroup.value).subscribe(res=>{
        this.loading = false;
        this.dialog.open(NotifyboxComponent, {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            isclose:true,
            message: res['message']
          }
        }).afterClosed().subscribe(result => {
          if (result) {
            this.dialogRef.close(this.formGroup.value);
          }
        });
      }, (err => {
        this.loading = false;
        // push error
        if (err.error.errors && err.error.errors.push_back) {
          this.dialog.open(NotifyboxComponent, {
            disableClose:true,
            data: {
              reload:false,
              label:'Ok',
              isclose:true,
              message: err.error.errors.push_back[0]
            }
          }).afterClosed().subscribe(result => {
            if (result) {
              // this.dialogRef.close(this.formGroup.value);
            }
          });
        }
        this._travel.setErrors(err.error.errors);
        this._travel.triggerErrors(err.error.errors);
      }));
    }

  }

}
